<template>
  <div>
    <NewNavbar variant="standard" />
    <nuxt />
    <OFooter
      :review-data="reviewData"
      :locale="locale"
      :year="$moment().format('YYYY')"
      :faq-column="footer.faqColumn"
      :how-does-it-work-column="footer.howDoesItWorkColumn"
      :legal-column="footer.legalColumn"
    />
  </div>
</template>

<script>
import { unauthenticated } from '@/mixins/layouts'
import footer from '@/mixins/footer'
import { mapState } from 'vuex'
const NewNavbar = () => import('@/components/NewNavbar')
const OFooter = () => import('@/components/OFooter')

export default {
  name: 'LayoutDefault',
  components: {
    NewNavbar,
    OFooter
  },
  mixins: [unauthenticated, footer],
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  }
}
</script>
